// 配置
let dev = {
  safePaths: ['/login'],
  apiBaseURL: 'api',
  imgBaseUrl: 'http://devphp.itcast.cn/e-learning-app-api/',
  token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImp0aSI6IjJNd1kyYmpnNFdCYlhQMGoifQ',
  imgServer: '',
  widthLimit:600
}

let pro = {
  safePaths: ['/login'],
  apiBaseURL: '/e-learning-app-api/index.php/api/mob/v1/api',
  imgBaseUrl: 'http://devphp.itcast.cn/e-learning-app-api/',
  token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImp0aSI6IjJNd1kyYmpnNFdCYlhQMGoifQ"',
  imgServer: '',
  widthLimit:600
}

export default process.env.NODE_ENV === 'development' ? dev : pro



// WEBPACK FOOTER //
// ./src/utils/config.js